/**
 * Formats a float number into Ukrainian currency format (XXXX грн YY коп)
 * @param amount - The amount to format
 * @returns Formatted string
 */
export const formatMoney = (amount: number): string => {
  const [grn, kop] = amount.toFixed(2).split('.');
  return `${grn} грн ${kop.padStart(2, '0')} коп`;
};
